import { IToggle, useFlags } from '@unleash/proxy-client-react';

const useDHFlags = (): IToggle[] => {
  const flags = useFlags();

  return flags;
};

export default useDHFlags;
